import type { ReactNode } from 'react';
import { Flex, theme } from 'antd';
import type { OutcomeTone } from './OutcomeTone';
import { outcomeToneTokens } from './OutcomeTone';

interface OutcomeRowProps {
  tone: OutcomeTone;
  /** Usually an `OutcomeIcon`. */
  icon: ReactNode;
  /** Dims the row: it happened, but it is not what the reader is scanning for. */
  muted?: boolean;
  /** First line — the subject the outcome is about. */
  title: ReactNode;
  /** Everything under the title: status label, reasons, links. */
  children?: ReactNode;
}

/** One tinted, bordered row in a list of per-object outcomes. */
export const OutcomeRow = ({
  tone,
  icon,
  muted,
  title,
  children,
}: OutcomeRowProps) => {
  const { token } = theme.useToken();
  const c = outcomeToneTokens(tone, token);

  return (
    <Flex
      gap={token.marginSM}
      align="flex-start"
      style={{
        border: `${token.lineWidth}px solid ${c.border}`,
        background: c.bg,
        borderRadius: token.borderRadiusLG,
        padding: `${token.paddingSM}px ${token.padding}px`,
        opacity: muted ? 0.7 : 1,
      }}
    >
      {icon}
      <div style={{ minWidth: 0, flex: 1 }}>
        {title}
        {children}
      </div>
    </Flex>
  );
};
